<template>
    <v-modal
        name="fillDetailsFromUniversalSearch"
        :width="700"
        height="100%"
        close-button
    >
      <div class="search">
        <universal-search>
          <template #app-custom-action="{ app }">
            <v-button
              type="primary"
              @click.native="$emit('app-chosen', app)"
            >
              {{ $t('CHOOSE') }}
            </v-button>
          </template>
        </universal-search>
      </div>
    </v-modal>
</template>

<script>
import VModal from '@/components/VModal.vue';
import UniversalSearch from '@/components/UniversalSearch/UniversalSearch.vue';
import VButton from '@/components/Button.vue';

export default {
  components: {
    VModal, UniversalSearch, VButton,
  },
};
</script>

<style lang="scss" scoped>
.search {
  padding-top: 10px;
}
</style>
